import { Fragment, useEffect, useState } from 'react';
import './header.css';
import { useLocation, useNavigate } from 'react-router-dom';
import { Box, IconButton, List, ListItem, ListItemButton, ListItemText, MenuItem, Select, SwipeableDrawer, Typography } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import LanguageIcon from '@mui/icons-material/Language';
import logo from "../../assets/logo.png";
import TranslateIcon from '@mui/icons-material/Translate';

const SideHeaderItem = ({ pageNavigate, setState, page, nav }) => {
    return <ListItem>
        <ListItemButton sx={{ color: '#206A5D' }} onClick={() => {
            pageNavigate(nav, nav === 'rooms' ? 'all' : '')
            setState(false)
        }}>
            <ListItemText sx={{ textAlign: 'center' }} primary={page} />
        </ListItemButton>
    </ListItem>
}


const SideHeader = ({ pageNavigate, setState }) => {
    return <Box sx={{ width: 250 }}>
        <List>
            <SideHeaderItem pageNavigate={pageNavigate} setState={setState} page='Home' nav='home' />
            <SideHeaderItem pageNavigate={pageNavigate} setState={setState} page='Rooms' nav='rooms' />
            <SideHeaderItem pageNavigate={pageNavigate} setState={setState} page='History' nav='history' />
            <SideHeaderItem pageNavigate={pageNavigate} setState={setState} page='Attraction' nav='attraction' />
            <SideHeaderItem pageNavigate={pageNavigate} setState={setState} page='Gallery' nav='gallery' />
            <SideHeaderItem pageNavigate={pageNavigate} setState={setState} page='Contact' nav='contact' />
        </List>
    </Box>
}



export const Header = ({ pageData, dispatch }) => {


    const location = useLocation();

    const [page, setPage] = useState(pageData.page)
    const [lng, setLng] = useState('en')

    const navigate = useNavigate()

    const pageNavigate = (page, _selected = null, group = null, check) => {

        // if(page === 'rooms') _selected = 'all'

        // console.log(check);


        const state = (_selected !== 'all' || _selected !== null) ? _selected : (page === 'rooms' ? 'all' : null)
        // console.log(page, state);

        setPage(`${page}`)
        navigate(`${page === 'home' ? '/' : page}`)
        dispatch({
            type: 'navigate',
            page: page,
            data: {
                state,
                group,
                check: pageData.data.check
            }
        })
    }


    useEffect(() => {

        const page = location.pathname.replace("/", "");
        let goPage = pageData.page
        // console.log(pageData);
        // console.log('Pages: ', page, ',', pageData.page);
        if (pageData.page === 'home' && page != pageData.page && page != '') {
            goPage = page
        }

        // console.log("Render: ", page,  pageData.page, ', State: ', pageData.data.state, pageData.data.group, pageData.data.check);
        pageNavigate(goPage, pageData.data.state, pageData.data.group, pageData.data.check)

    }, [pageData.data.state])


    const [state, setState] = useState(false)


    return (
        <div className={`header ${page === 'home' ? 'home' : ''}`}>
            <div className="header-box">
                <div className="header-title" style={{ display: 'flex', gap: '20px' }}>
                    <img src={logo} alt="Logo" width="50" />
                    <Typography sx={{ fontSize: { xs: '20px', sm: '32px', md: '28px' }, display: { xs: page === 'home' ? 'none' : 'bloak', sm: 'block' } }} className="header-title notranslate">Heaven Upon Rice Fields</Typography >
                </div>

                <Fragment >
                    <IconButton sx={{ display: { xs: 'block', md: 'none' }, color: 'white' }} onClick={() => setState(!state)}><MenuIcon /></IconButton>
                    <SwipeableDrawer
                        anchor='right'
                        open={state}
                        onClose={() => setState(false)}
                        onOpen={() => setState(true)}
                    >
                        <SideHeader pageNavigate={pageNavigate} setState={setState} />
                    </SwipeableDrawer>
                </Fragment>


                <Box sx={{ display: { xs: 'none', md: 'flex' } }} className="header-page-box">
                    <div className={`page-box ${page === 'home' ? 'active' : ''}`} onClick={() => pageNavigate('home')}>
                        <p className="page-title">Home</p>
                    </div>
                    <div className={`page-box ${page === 'rooms' ? 'active' : ''}`} onClick={() => pageNavigate('rooms', 'all')}>
                        <p className="page-title">Rooms</p>
                    </div>
                    <div className={`page-box ${page === 'history' ? 'active' : ''}`} onClick={() => pageNavigate('history')}>
                        <p className="page-title">History</p>
                    </div>
                    <div className={`page-box ${page === 'attraction' ? 'active' : ''}`} onClick={() => pageNavigate('attraction')}>
                        <p className="page-title">Attraction</p>
                    </div>
                    <div className={`page-box ${page === 'gallery' ? 'active' : ''}`} onClick={() => pageNavigate('gallery')}>
                        <p className="page-title">Gallery</p>
                    </div>
                    <div className={`page-box ${page === 'contact' ? 'active' : ''}`} onClick={() => pageNavigate('contact')}>
                        <p className="page-title">Contact</p>
                    </div>

                    <div className="language-selector notranslate" no sx={{ display: 'flex' }}>
                        {/* <TranslateIcon sx={{ color: 'white', mr: 1 }} /> */}
                        <Select
                            value={lng}
                            onChange={(e) => {
                                setLng(e.target.value)
                                window.translateTo(e.target.value)
                            }}
                            sx={{
                                color: 'white',
                                // border: '1px solid white',
                                height: '25px',
                                padding: '6px 0px',
                                borderRadius: '10px',
                                '& .MuiSvgIcon-root': { color: 'white' },
                                '& .MuiOutlinedInput-notchedOutline': { border: 'none' },
                                fontSize: '11px',
                                backgroundColor: 'rgba(255,255,255,0.1)',
                            }}
                        >
                            <MenuItem value="en" className='notranslate'>English</MenuItem>
                            <MenuItem value="fr" className='notranslate'>Français</MenuItem>
                            <MenuItem value="de" className='notranslate'>Deutsch</MenuItem>
                            <MenuItem value="it" className='notranslate'>Italiano</MenuItem>
                            <MenuItem value="ja" className='notranslate'>日本語</MenuItem>
                            <MenuItem value="zh-CN" className='notranslate'>中文</MenuItem>

                        </Select>
                    </div>

                    {/* <IconButton sx={{ color: 'white', borderRadius: '10px', gap: '5px' }}>
                        <LanguageIcon sx={{ fontSize: 'medium' }} />
                        <div class="dropdown notranslate" id="dropdown" sx={{display: 'none'}}>
                            <span id="dropdown-title">Language</span>
                            <div class="dropdown-content notranslate">
                                <div class="dropdown-content-list">
                                    <p onclick="translateTo('fr', 'French')">French</p>
                                    <p onclick="translateTo('nl', 'Dutch')">Dutch</p>
                                    <p onclick="translateTo('ja', 'Japanese')">Japanese</p>
                                    <p onclick="translateTo('en', 'English')">English</p>
                                    <p onclick="translateTo('it', 'Italian')">Italian</p>
                                    <p onclick="translateTo('zh-CN', 'Chinese')">Chinese</p>
                                    <p onclick="translateTo('ko', 'Korean')">Korean</p>
                                    <p onclick="translateTo('ru', 'Russian')">Russian</p>
                                </div>
                            </div>
                        </div>
                    </IconButton> */}

                </Box>
            </div>
        </div>
    )
}
